export class BuildDetails {
  commitHash: string;
}
